import { render, staticRenderFns } from "./TriesOverview.vue?vue&type=template&id=f05fd288&scoped=true"
import script from "./TriesOverview.vue?vue&type=script&lang=js"
export * from "./TriesOverview.vue?vue&type=script&lang=js"
import style0 from "./TriesOverview.vue?vue&type=style&index=0&id=f05fd288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05fd288",
  null
  
)

export default component.exports